import { render, staticRenderFns } from "./PackageKidsUpdateDialog.vue?vue&type=template&id=1c01897c&scoped=true"
import script from "./PackageKidsUpdateDialog.vue?vue&type=script&lang=js"
export * from "./PackageKidsUpdateDialog.vue?vue&type=script&lang=js"
import style0 from "./PackageKidsUpdateDialog.vue?vue&type=style&index=0&id=1c01897c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c01897c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c01897c')) {
      api.createRecord('1c01897c', component.options)
    } else {
      api.reload('1c01897c', component.options)
    }
    module.hot.accept("./PackageKidsUpdateDialog.vue?vue&type=template&id=1c01897c&scoped=true", function () {
      api.rerender('1c01897c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/Package/PackageKidsUpdateDialog.vue"
export default component.exports